import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=26ddf69f&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=26ddf69f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ddf69f",
  null
  
)

export default component.exports